<template>
  <div>
    <SearchField
      :form="formInline"
      :formCtrl="formCtrl"
      @onSearch="onSearch"
      @onReset="onReset"
      @onChange="onSearchItemChange"
    >
      <template #start>
        <el-form-item
          v-if="user && [1, 5, 7].includes(user.user_group_id)"
          class="startBtn"
        >
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table
      ref="table"
      :tableHeight="tableHeight"
      :tableData="tableData"
      :cols="cols"
      :btns="btns"
      :page="page"
      :limit="limit"
      :total="total"
      :showIndex="true"
      :allBtnWidth="200"
      @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"
    >
      <template slot="gettrip" slot-scope="params">
        <div class="lcbtn" @click="showTrip(params.params)">
          {{ params.params.gettrip }}
        </div>
      </template>
      <template slot="btn1" slot-scope="params">
        <el-button
          class="positionbtn"
          type="primary"
          @click="showPosition(params.params)"
          size="mini"
          >位置</el-button
        >
      </template>
      <template slot="btn2" slot-scope="params">
        <el-button
          class="pathbtn"
          type="primary"
          @click="showPath(params.params)"
          size="mini"
          >轨迹</el-button
        >
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState } from "vuex";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "car",
      // formInline: {
      //   status: 1,
      // },
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          ...this.ctrls.license,
        },
        {
          label: "司机姓名",
          keyName: "driver",
          placeholder: "请填写司机姓名",
          type: "text",
        },
        {
          label: "押运员姓名",
          keyName: "escort",
          placeholder: "请填写押运员姓名",
          type: "text",
        },
        {
          label: "车种",
          keyName: "vtype",
          type: "select",
          options: [],
        },
        /*{
          label: "载货重量",
          keyName: "ton",
          placeholder: "请填写载货重量",
          type: "number",
        },*/
      ],
      cols: [
        { prop: "fleetname", label: "车队长" },
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "trailer", label: "挂车号", minwidth: 120 },
        { prop: "driver", label: "司机" },
        { prop: "escort", label: "押运员" },
        { prop: "vtype", label: "车种", minwidth: 120 },
        {
          prop: "ton",
          label: "载货重量",
          align: "right",
          className: "pr30",
          minwidth: 120,
        },
        { prop: "buytime", label: "车辆购入时间", minwidth: 120 },
        //{ prop: "carstatus", label: "车辆状态" },
        {
          prop: "money",
          label: "预支款",
          align: "right",
          className: "pr30",
          minwidth: 120,
        },
        { prop: "gettrip", label: "本月行驶里程", minwidth: 120, slot: "gettrip" },
        { prop: "", label: "位置", slot: "btn1" },
        { prop: "", label: "轨迹", slot: "btn2" },
      ],
      btns: [
        {
          ...this.viewBtn,
          title: "查看",
          cb: ({ id, fleet, fleetname }) => {
            const query = {
              mode: "view",
              id,
            };
            if (fleet) {
              query["fleetid"] = fleet;
            }
            if (fleetname) {
              query["fleetName"] = fleetname;
            }
            this.$router.push({
              path: "/vehicle/view",
              query,
            });
          },
        },
        {
          ...this.editBtn,
          cb: ({ id, fleet, fleetname }) => {
            const query = {
              mode: "edit",
              id,
            };
            if (fleet) {
              query["fleetid"] = fleet;
            }
            if (fleetname) {
              query["fleetName"] = fleetname;
            }
            this.$router.push({
              path: "/vehicle/detail",
              query,
            });
          },
        },
        {
          class: "insurancebtn",
          img: require("@/assets/img/icon_insurance.png"),
          unimg: require("@/assets/img/icon_insurance_hover.png"),
          title: "保险",
          cb: ({ id, license }) => {
            this.$router.push(
              `/vehicle/insurance?car_type=1&id=${id}&license=${license}`
            );
          },
        },
        {
          class: "documentbtn",
          img: require("@/assets/img/icon_document.png"),
          unimg: require("@/assets/img/icon_document_hover.png"),
          title: "证件",
          cb: ({ id, license }) => {
            this.$router.push(`/vehicle/document?car_type=1&id=${id}&license=${license}`);
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id);
          },
        },
      ],
      baseParams: ["carstatus"],
      fleetName: "",
      list: ["在用", "停用", "报废"],
      team: [],
    };
  },
  computed: {
    ...mapState(["store"]),
  },
  methods: {
    delParamsPackage(params) {
      params["headers"] = {
        "X-Method": "delete",
        "X-Module": "car",
      };

      // console.log('params', { ...params })
    },

    showTrip({ license }) {
      this.$router.push(`/vehicle/viewTrip?license=${license}`);
    },

    addItem() {
      let fleetName = this.fleetName;
      // console.log(fleetName);
      const { fleet } = this.formInline;
      // console.log(fleet);
      // console.log(this.team);
      if (!fleetName && fleet && this.team && this.team.length) {
        this.team.map((v) => {
          if (v.id == fleet) {
            fleetName = v.nickname;
          }
        });
      }
      // console.log(fleetName);
      const query = {};
      if (fleet) {
        query["fleetid"] = fleet;
      }
      if (fleetName) {
        query["fleetName"] = fleetName;
      }
      // console.log(query);
      this.$router.push({
        path: "/vehicle/detail",
        query,
      });
    },

    setParams() {
      const { status } = this.$route.params;
      this.formInline.carstatus = this.list[status - 1];
      // this.formInline.fleet = this.team[idx - 1].id
      // this.fleetName = this.team[idx - 1].nickname
      // console.log(this.formInline)
      this.getList();
    },
    onSearchItemChange({ key }) {
      // console.log(key)
      if (key === "fleet") {
        // console.log(this.formInline)
        this.getList();
        // this.team.map((v, i) => {
        //   console.log(v)
        //   if (v.id === value) {
        //     console.log(i)
        //     this.$router.push(`/vehicle/manage/table/${i + 1}`)
        //   }
        // })
      }
    },
    getOptions() {
      this.post(
        `${this.baseUrl}/index`,
        {},
        ({ team, cartype }) => {
          this.team = team;
          this.setParams();
          this.formCtrl.map((v) => {
            if (v.keyName == "vtype") {
              v.options = cartype.map((val) => {
                return {
                  label: val.name,
                  value: val.name,
                };
              });
            } else if (v.keyName === "fleet") {
              v.options = team.map((val) => {
                return {
                  label: val.nickname,
                  value: val.id,
                };
              });
            }
          });
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    showPosition({ license }) {
      console.log(license);
      // this.post(`${this.baseUrl}/location`, { license }, ({ msg, url }) => {
      //   if (msg === 'success' && url) {
      //     // location.href = url
      //     this.$router.push(`/vehicle/viewurl?url=${encodeURIComponent(url)}&title=${license + '现在位置'}`)
      //   }
      // }, err => {
      //   console.log(err)
      //   this.$message({
      //     type: 'error',
      //     message: '获取数据失败，请稍后重试！'
      //   });
      // })
    },
    showPath({ license }) {
      console.log(license);
      // this.post(`${this.baseUrl}/history`, { license }, ({ msg, url }) => {
      //   if (msg === 'success' && url) {
      //     // location.href = url
      //     this.$router.push(`/vehicle/viewurl?url=${encodeURIComponent(url)}&title=${license + '历史轨迹'}`)
      //   }
      // }, err => {
      //   console.log(err)
      //   this.$message({
      //     type: 'error',
      //     message: '获取数据失败，请稍后重试！'
      //   });
      // })
    },
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      // console.log(this.$route.params)
      this.setParams();
    },
  },
  mounted() {
    this.getOptions();
    const { user_group_id } = this.user;
    if (![1, 5, 7].includes(user_group_id)) {
      this.btns.length = 1;
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-form--inline .el-form-item:nth-last-child(3) {
  margin-right: 20px;
}

.lcbtn {
  color: #409eff;
  cursor: pointer;
}
</style>
